module.exports = __webpack_public_path__ + "img/ornament-847.577c41ff.png";